"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.number.constructor");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _moment = _interopRequireDefault(require("moment"));

var _lastMileDeliveryWellcome = require("@/mixins/last-mile-delivery-wellcome/last-mile-delivery-wellcome");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TIME_STEPPER_KEY = 'lmTimeStepper';

var LMDGanttFilterComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDGanttFilterComponent, _Mixins);

  var _super = _createSuper(LMDGanttFilterComponent);

  function LMDGanttFilterComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDGanttFilterComponent);
    _this = _super.apply(this, arguments);
    _this.filters = [{
      'key': 'PlateNum',
      'label': 'plateNumber'
    }, {
      'key': 'Status',
      'label': 'status'
    }, {
      'key': 'TruckSchedule',
      'label': 'truckSchedule'
    }, {
      'key': 'TruckType',
      'label': 'truckType'
    }, {
      'key': 'TruckCommodityType',
      'label': 'truckCommodityType'
    }, {
      'key': 'VehicleType',
      'label': 'vehicleType'
    }, {
      'key': 'Zone',
      'label': 'zone'
    }];
    _this.bufferTrucks = [];
    _this.selectedTrucks = [];
    _this.trucksSchedule = [];
    _this.truckScheduleValue = '';
    _this.truckCommodityTypes = ['A', 'D', 'WM'];
    _this.truckCommodityValue = ['D'];
    _this.switchValue = false;
    _this.selectValue = 'PlateNum';
    _this.inputValue = null;
    _this.isLocalEnableAllTrucks = true;
    _this.timeSteppers = [15, 30, 60];
    _this.timeStepper = 30;
    _this.cargoTruckVal = null;
    return _this;
  }

  (0, _createClass2.default)(LMDGanttFilterComponent, [{
    key: "onTrucksChanges",
    value: function onTrucksChanges(newVal) {
      if (newVal.length > this.bufferTrucks.length) {
        this.bufferTrucks = (0, _toConsumableArray2.default)(newVal);
      }
    }
  }, {
    key: "onTimeStepperChanges",
    value: function onTimeStepperChanges(newVal) {
      window.localStorage.setItem(TIME_STEPPER_KEY, newVal);
    }
  }, {
    key: "onIsManualAssignLoadingChanges",
    value: function onIsManualAssignLoadingChanges() {
      this.updateBufferTrucks(this.cargoTruckVal, false);
    }
  }, {
    key: "onIsAutoAssignLoadingChanges",
    value: function onIsAutoAssignLoadingChanges() {
      this.updateBufferTrucks(this.cargoTruckVal, false);
    }
  }, {
    key: "onBooleanEnableTrucksChanges",
    value: function onBooleanEnableTrucksChanges(newVal) {
      if (newVal) {
        this.$emit('onEnableAllTrucks');
        return;
      }

      this.$emit('onDisableAllTrucks');
      return;
    }
  }, {
    key: "onTruckFiltersChanges",
    value: function onTruckFiltersChanges(newVal, oldVal) {
      if (oldVal !== undefined) {
        this.$getTrucks();
        this.cargoTruckVal = null;
        var selectedTrucks = newVal.filter(function (i) {
          return i.key === 'PlateNum';
        }).map(function (i) {
          return i.value;
        });
        this.selectedTrucks = (0, _toConsumableArray2.default)(selectedTrucks);
      }
    }
  }, {
    key: "currentPlanOrdersLen",
    get: function get() {
      if (this.helper.isUndefined(this.$plan.orders)) {
        return 0;
      }

      return this.$plan.orders.length;
    }
  }, {
    key: "created",
    value: function () {
      var _created = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var timeStepper, res, trucksSchedule, bufferTrucksSchedule;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.isLocalEnableAllTrucks = this.isEnableAllTrucks;
                timeStepper = window.localStorage.getItem(TIME_STEPPER_KEY);

                if (!this.helper.isUndefined(timeStepper)) {
                  this.timeStepper = Number(timeStepper);
                  this.handleTimeStepperChanges(this.timeStepper);
                }

                _context.next = 5;
                return this.lastMileDeliveryAPI.getTrucksSchedule({
                  query: "JobDate:0000-00-00"
                });

              case 5:
                res = _context.sent;
                trucksSchedule = this.helper.uniq(this.helper.get(res, 'data', []).map(function (i) {
                  return i.TimeWindow;
                }));
                bufferTrucksSchedule = [];
                trucksSchedule.forEach(function (time, index) {
                  var tempSingleTimeArr = time.split('-');
                  bufferTrucksSchedule.push({
                    time: (0, _moment.default)(tempSingleTimeArr[0].trim(), 'HH:mm').unix(),
                    index: index
                  });
                });
                bufferTrucksSchedule.sort(function (a, b) {
                  return a.time - b.time;
                });
                bufferTrucksSchedule.forEach(function (t) {
                  _this2.trucksSchedule.push(trucksSchedule[t.index]);
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function created() {
        return _created.apply(this, arguments);
      }

      return created;
    }()
  }, {
    key: "handleCloseTag",
    value: function handleCloseTag(filter) {
      if (filter) {
        var index = this.helper.findIndex(this.$truckFilters, {
          'key': filter.key,
          'value': filter.value
        });
        var tmpArr = this.helper.cloneDeep(this.$truckFilters);
        tmpArr.splice(index, 1);
        this.$truckFilters = tmpArr;
      }
    }
  }, {
    key: "addFilter",
    value: function addFilter(type) {
      var _this3 = this;

      if (/\S/.test(this.inputValue) || type === 'switch' || this.truckCommodityValue.length > 0 || this.truckScheduleValue) {
        var index = this.helper.findIndex(this.$truckFilters, {
          'key': this.selectValue,
          'value': this.inputValue
        });

        if (index === -1) {
          var filter = {
            'key': this.selectValue,
            'label': this.helper.get(this.helper.find(this.filters, {
              'key': this.selectValue
            }), 'label', ''),
            'value': this.inputValue
          };
          var filters = (0, _toConsumableArray2.default)(this.$truckFilters);

          if (type === 'truckSchedule') {
            filter.value = this.truckScheduleValue;
          }

          if (type === 'truckCommodityType') {
            filter.value = this.truckCommodityValue.toString();
          }

          if (type === 'plateNum') {
            filter.value = this.inputValue[0];
          }

          if (type !== 'switch') {
            filters.push(filter);
          }

          if (type === 'switch' && !this.helper.isUndefined(this.selectValue)) {
            var filterIndex = this.helper.findIndex(filters, function (f) {
              return f['label'] === _this3.selectValue;
            });

            switch (this.selectValue) {
              case 'Status':
                filter['value'] = this.switchValue ? this.$i18n.t('truckFilter.enabledTrucks') : this.$i18n.t('truckFilter.disabledTrucks');
                break;
            }

            if (filterIndex !== -1) {
              filters[filterIndex] = filter;
            } else {
              filters.push(filter);
            }
          }

          this.$truckFilters = filters;
        }
      }

      this.inputValue = '';
    }
  }, {
    key: "handleTimeStepperChanges",
    value: function handleTimeStepperChanges(newVal) {
      this.$emit('onTimeStepperChanges', newVal);
    }
  }, {
    key: "handleTruckHasCargo",
    value: function handleTruckHasCargo(newVal) {
      this.updateBufferTrucks(newVal, true);
      this.$selectedTruck = null;
    }
  }, {
    key: "updateBufferTrucks",
    value: function updateBufferTrucks(newVal, isEmit) {
      var _this4 = this;

      var hasValue;

      if (newVal === null) {
        hasValue = false;
        this.$bufferTrucks = this.helper.cloneDeep(this.$trucks);
      } else if (newVal === 'nonEmptyTrucks') {
        hasValue = true;
        this.$bufferTrucks = this.$trucks.filter(function (truck) {
          return !!_this4.$plan.trucks.find(function (t) {
            return t.truckId === truck['id'];
          });
        });
      } else {
        hasValue = true;
        this.$bufferTrucks = this.$trucks.filter(function (truck) {
          return !_this4.$plan.trucks.find(function (t) {
            return t.truckId === truck['id'];
          });
        });
      }

      if (isEmit) {
        this.$emit('updateBufferTrucks', {
          hasValue: hasValue
        });
      }
    }
  }]);
  return LMDGanttFilterComponent;
}((0, _vuePropertyDecorator.Mixins)(_lastMileDeliveryWellcome.LastMileDeliveryMixin));

(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], LMDGanttFilterComponent.prototype, "isAutoAssign", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: true
})], LMDGanttFilterComponent.prototype, "isEnableAllTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$trucks')], LMDGanttFilterComponent.prototype, "onTrucksChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('timeStepper')], LMDGanttFilterComponent.prototype, "onTimeStepperChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('isManualAssignLoading')], LMDGanttFilterComponent.prototype, "onIsManualAssignLoadingChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('isAutoAssignLoading')], LMDGanttFilterComponent.prototype, "onIsAutoAssignLoadingChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('isLocalEnableAllTrucks')], LMDGanttFilterComponent.prototype, "onBooleanEnableTrucksChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$truckFilters', {
  deep: true,
  immediate: true
})], LMDGanttFilterComponent.prototype, "onTruckFiltersChanges", null);
LMDGanttFilterComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDGanttFilterComponent',
  components: {
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-tag': _elementUi.Tag,
    'el-input': _elementUi.Input,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-switch': _elementUi.Switch,
    'el-button': _elementUi.Button,
    'el-tooltip': _elementUi.Tooltip
  }
})], LMDGanttFilterComponent);
var _default = LMDGanttFilterComponent;
exports.default = _default;